import { render } from "./Loading.vue?vue&type=template&id=47b5bae2"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=47b5bae2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__